import { Breakpoints, styled } from '@volkswagen-onehub/components-core';

import { VWTheme } from '../../../../shared/typings/vw-theme';

export const StyledButtonsContainer: any = styled.div`
  ${({ theme }: { theme: VWTheme }) => {
    return `
      display: flex;
      gap: ${theme.size.static350};
      justify-content: space-between;

      @media (min-width: ${Breakpoints.b560}px) {
        gap: ${theme.size.static400};
      }

      @media (min-width: ${Breakpoints.b1920}px) {
        gap: ${theme.size.static350};
        justify-content: flex-end;
      }
    `;
  }}
`;
